import React, { PureComponent } from 'react';
import unPublished from '../../assets/img/unpublished.svg';

interface TimelineObjectProps {
  isOverview?: boolean;
  isFirst: boolean;
  ratePlanId: number;
  duration: number;
  isAdjustment?: boolean;
  isInactive?: boolean;
  isSelected?: boolean;
  onClick: (id: number) => void;
  ratePlanName: string;
  planUnpublished?: boolean;
}

export class TimelineObject extends PureComponent<TimelineObjectProps> {

  getClass = () => {
    let className = this.props.isAdjustment ? 'd-flex justify-content-start pl-1 align-items-center timeline-table-object-secondary ' : 'd-flex justify-content-start align-items-center timeline-table-object ';

    if (this.props.isInactive) className = className.concat('timeline-object-inactive ');
    else if (this.props.isSelected) className = className.concat('timeline-object-selected');
    else className = className.concat('timeline-object-active');

    return className;
  };

  getCellClass = () => {
    let className = '';
    if (this.props.isFirst) className = className.concat('pt-1 ');

    return this.props.isAdjustment ? className.concat('adjustment-cell') : className.concat('standard-rate-cell');
  };

  render() {
    return (
      <td className={this.getCellClass()} colSpan={this.props.duration}>
        <div style={{ width: this.props.duration * (this.props.isOverview ? 20 : 8) }} onClick={() => this.props.onClick(this.props.ratePlanId)} id={String(this.props.ratePlanId)} role="button" className={this.getClass()}>
          {this.props.planUnpublished && this.props.duration > 1 && (
            <img alt="unpublished" className="unpublished mr-1" src={unPublished}></img>
          )}
          {!this.props.isAdjustment && (
            <text className="timeline-object-text-container">
              {this.props.ratePlanName }
            </text>
          )}
        </div>
      </td>
    );
  }
}
